import React, { ReactElement } from 'react';
import { map } from 'lodash';
import accounting from 'accounting';
import TranslatorManager from 'ts-translate-js';

const tr = TranslatorManager.boundTR;

type OrderConfirmationTotalProps = {
    isMailDeliverySelected: boolean;
    totalKit: TotalKit;
    prepaidCardsTotalAmount?: number;
    transactionReceiptAmount?: number;
    showTaxes: boolean;
}

export type TotalKit = {
    subTotal: number;
    shippingFee: number;
    taxes: Tax[];
    total: number;
}

export type Tax = {
    name: string;
    amount: number;
}

export function OrderTotalFooter({
    isMailDeliverySelected, totalKit, showTaxes}: OrderConfirmationTotalProps): ReactElement {

    let subtotalCtrl = <tr>
        <td>{tr(`Sous total`)} :&nbsp;</td>
        <td>{accounting.formatMoney(totalKit.subTotal)}</td>
    </tr>;

    let shippingFeeCtrl = null;
    if (isMailDeliverySelected) {
        shippingFeeCtrl = <tr key="shippingFee">
            <td>{tr("Frais de livraison")} :&nbsp;</td>
            <td>{accounting.formatMoney(totalKit.shippingFee)}</td>
        </tr>;
    }

    let taxesCtrl = [];
    if(showTaxes) {
        taxesCtrl = map(totalKit.taxes, ((tax) => <tr key={tax.name}>
            <td>{tax.name} :&nbsp;</td>
            <td>{accounting.formatMoney(tax.amount)}</td>
        </tr>));
    }

    return <div className="total">
        <table>
            <tbody>
                {(showTaxes || shippingFeeCtrl != null) && subtotalCtrl}
                {shippingFeeCtrl}
                {taxesCtrl}
                <tr>
                    <td>{tr(`Total de la facture`)} :&nbsp;</td>
                    <td><strong>{accounting.formatMoney(totalKit.total)}</strong></td>
                </tr>
            </tbody>
        </table>
    </div>;
}